/* eslint-disable no-restricted-syntax */
/* eslint-disable global-require */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/extensions */
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import PropTypes from "prop-types"; // PropTypes for type checking
import Typography from "@material-ui/core/Typography"; // Typography component for text styling

// core components
import GridContainer from "components/Grid/GridContainer.js"; // Custom Grid container component
import GridItem from "components/Grid/GridItem.js"; // Custom Grid item component
import Button from "components/CustomButtons/Button.js"; // Custom Button component
import { connect } from "react-redux"; // Redux connect for state management

// ===== OPTION B: Removed ContextHolder from Frontegg =====
// import { ContextHolder } from "@frontegg/react";
import {
  loginRequest,
  setUserRole,
  setAppBarName,
  setLayoutName,
  authLogout, // ===== OPTION B: Use centralized logout =====
} from "../../Redux/Actions/LoginActions"; // Redux actions for login
import { redirectToFronteggLogout } from "../../authSession";
import styles from "../../assets/jss/material-dashboard-react/views/LoginPage.js"; // Custom styles for the login page

// Create custom styles using Material-UI's makeStyles
const useStyles = makeStyles(styles);

// ===== OPTION B: SessionOut with centralized logout =====
const SessionOut = (props) => {
  const classes = useStyles(); // Initialize styles

  // Function to handle logout and redirect to login page
  const onClick = () => {
    // Dispatch centralized logout action
    if (props.authLogout) {
      props.authLogout();
    }
    redirectToFronteggLogout();
  };

  return (
    <div className={classes.container}>
      {/* Grid container for layout */}
      <GridContainer>
        <GridItem xs>
          <div className={classes.root}>
            {/* Display logo */}
            <img
              className={classes.logo}
              src={require("../../assets/img/vikingstransparent_logo.png")}
            />
            {/* Display session timeout message */}
            <Typography color="textPrimary" variant="h4" gutterBottom>
              uh oh!
            </Typography>
            <Typography color="textPrimary" variant="body1" gutterBottom>
              Looks like your session has timed out and we need to log you in
              again.
            </Typography>
            <Typography color="textPrimary" variant="body1" gutterBottom>
              Click on the button below to log in:
            </Typography>
            {/* Button to log in again */}
            <Button
              onClick={onClick}
              variant="contained"
              color="primary"
              size="large"
            >
              Login Again
            </Button>
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
};

// Define prop types for the component
SessionOut.propTypes = {
  history: PropTypes.object, // React Router history object for navigation
  prop: PropTypes.any, // Additional props (if any)
  authLogout: PropTypes.func, // ===== OPTION B: Centralized logout action =====
};

// Map Redux state to component props
const mapStateToProps = ({ app }) => ({
  userData: app.userDetails, // Map user details from Redux state
});

// Connect component to Redux and export
export default connect(mapStateToProps, {
  loginRequest, // Redux action to handle login requests
  setUserRole, // Redux action to set user role
  setAppBarName, // Redux action to set app bar name
  setLayoutName, // Redux action to set layout name
  authLogout, // ===== OPTION B: Centralized logout action =====
})(SessionOut);
